import React, { useState, useEffect } from "react";
import Header from "../../../commons/Header/Header";
import Sidebar from "../../../commons/Sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import viewImage from "../../../assets/images/icons/view.svg";
function PayoutManagementDriverView() {
  
  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Payout Management (Driver)</h3>
            </div>
            <div className="d-flex">
              <div class="mt-3">
                <Link to='/view-order' class="btn btn-default rounded-lg">Back</Link>
              </div>
            </div>
            <div className="table-responsive px-0 mt-4">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th width="200">S No</th>
                    <th width="150">Delivery Date</th>
                    <th>Delivery Amount</th>
                    <th>Delivery Status</th>
                    <th>Amount <br/>Transferred</th>
                    <th>Driver Earnings</th>
                    <th>Amount <br/>Paid</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>                      
                    <tr>
                        <td className="text-left">1</td>
                        <td>12-Mar-2022</td>
                        <td>£32.8</td>
                        <td>Delivered</td>
                        <td>£50.2</td>
                        <td>£10</td>
                        <td>£36</td>
                        <td>
                            <div className="d-flex align-items-center justify-content-center">
                                <Link to='/view-order' className="mx-2">
                                    <img src={viewImage} alt="View" />
                                </Link>
                            </div>
                        </td>
                    </tr>
                    <tr>
                         <td className="text-left">2</td>
                        <td>12-Mar-2022</td>
                        <td>£32.8</td>
                        <td>Delivered</td>
                        <td>£50.2</td>
                        <td>£10</td>
                        <td>£36</td>
                        <td>
                            <div className="d-flex align-items-center justify-content-center">
                                <Link to='/view-order' className="mx-2">
                                    <img src={viewImage} alt="View" />
                                </Link>
                            </div>
                        </td>
                    </tr>
                    <tr>
                         <td className="text-left">3</td>
                        <td>12-Mar-2022</td>
                        <td>£32.8</td>
                        <td>Delivered</td>
                        <td>£50.2</td>
                        <td>£10</td>
                        <td>£36</td>
                        <td>
                            <div className="d-flex align-items-center justify-content-center">
                                <Link to='/view-order' className="mx-2">
                                    <img src={viewImage} alt="View" />
                                </Link>
                            </div>
                        </td>
                    </tr>
                    <tr>
                         <td className="text-left">4</td>
                        <td>12-Mar-2022</td>
                        <td>£32.8</td>
                        <td>Delivered</td>
                        <td>£50.2</td>
                        <td>£10</td>
                        <td>£36</td>
                        <td>
                            <div className="d-flex align-items-center justify-content-center">
                                <Link to='/view-order' className="mx-2">
                                    <img src={viewImage} alt="View" />
                                </Link>
                            </div>
                        </td>
                    </tr>
                    <tr>
                         <td className="text-left">5</td>
                        <td>12-Mar-2022</td>
                        <td>£32.8</td>
                        <td>Delivered</td>
                        <td>£50.2</td>
                        <td>£10</td>
                        <td>£36</td>
                        <td>
                            <div className="d-flex align-items-center justify-content-center">
                                <Link to='/view-order' className="mx-2">
                                    <img src={viewImage} alt="View" />
                                </Link>
                            </div>
                        </td>
                    </tr>
                    {/* <tr>
                      <td colSpan="6" className="text-center py-4">
                        No Data Found
                      </td>
                    </tr> */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PayoutManagementDriverView;